<template>
  <div class="observatory-usage-guide">
    <div
      v-for="(usageItem, index) in usageGuide"
      :key="index"
      class="legend-area"
    >
      <div class="legend-title" v-if="usageItem.title">
        {{ usageItem.title }}
      </div>
      <v-card class="legend" tile elevation="5">
        <div
          v-for="(o, index) in usageItem.colors"
          :key="index"
          class="val"
          :style="{ backgroundColor: o.color }"
        >
          {{ o.value }}
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { isPublicMode } from "../../../utils/common";
import { OBSERVATORY } from "../../../enums/Type";
export default {
  name: "ObservatoryUsageGuide",
  data() {
    return {
      //
    };
  },

  computed: {
    targetTypes() {
      let targets = this.$store.getters.riskSubControl.observatory;
      if (isPublicMode === true) {
        targets = targets.filter(t => t !== OBSERVATORY.PUMP.code);
      }
      return targets;
    },
    usageGuide() {
      const guide = [];
      if (this.targetTypes.includes(OBSERVATORY.STAGE.code)) {
        guide.push({
          title: "水位",
          colors: [
            { color: "#000000", value: "氾濫発生水位" },
            { color: "#ad02ad", value: "氾濫危険水位" },
            { color: "#ff2800", value: "避難判断水位" },
            { color: "#ffa500", value: "氾濫注意水位" },
            { color: "#008000", value: "水防団待機水位" },
            { color: "#1e709f", value: "平常" },
            { color: "#AAAAAA", value: "休止・欠測等" }
          ]
        });
      }
      if (this.targetTypes.includes(OBSERVATORY.RAIN.code)) {
        guide.push({
          title: "雨量(mm/10分)",
          colors: [
            { color: "#FF0000", value: "20～" },
            { color: "#800080", value: "10～19" },
            { color: "#D88100", value: "5～9" },
            { color: "#1E42AF", value: "1～4" },
            { color: "#233559", value: "0" },
            { color: "#AAAAAA", value: "休止・欠測等" }
          ]
        });
      }
      const manholes = [
        OBSERVATORY.MANHOLE.code,
        OBSERVATORY.MANHOLE_WATERWAY.code
      ];
      if (this.targetTypes.some(t => manholes.includes(t))) {
        guide.push({
          title: "ﾏﾝﾎｰﾙ/水路",
          colors: [
            { color: "#AD02AD", value: "危険水位" },
            { color: "#FFA500", value: "注意水位" },
            { color: "#24B9AA", value: "平常" }
          ]
        });
      }
      if (this.targetTypes.includes(OBSERVATORY.PUMP.code)) {
        guide.push({
          title: "ポンプ",
          colors: [
            { color: "#E32E37", value: "運転" },
            { color: "#15935D", value: "停止" },
            { color: "#000000", value: "故障" },
            { color: "#AAAAAA", value: "欠測" }
          ]
        });
      }
      if (this.targetTypes.includes(OBSERVATORY.SUIJIN.code)) {
        let colors = [
          { color: "#ad02ad", value: "浸水検知" },
          { color: "#ffd600", value: "浸水注意" },
          { color: "#cddc39", value: "待機中" },
          { color: "#212121", value: "メンテ中" }
        ];
        guide.push({
          title: "浸水ｾﾝｻ",
          colors: colors
        });
      }
      return guide;
    }
  },

  created() {
    //
  }
};
</script>

<style scoped lang="scss">
.observatory-usage-guide {
  overflow: hidden;
  padding-bottom: 10px;
}
.legend-area {
  float: right;
  margin-left: 5px;
  .legend-title {
    text-align: right;
    font-size: 12px;
    font-weight: bold;
    white-space: pre;
    text-shadow: 1px 1px 0 #ffffff, -1px 1px 0 #ffffff, 1px -1px 0 #ffffff,
      -1px -1px 0 #ffffff;
  }
  .legend {
    float: left;
    .val {
      color: #ffffff;
      text-shadow: 1px 1px 0 #2c2c2c, -1px 1px 0 #2c2c2c, 1px -1px 0 #2c2c2c,
        -1px -1px 0 #2c2c2c;
      font-weight: bold;
      font-size: 12px;
      min-width: 12px;
      text-align: center;
      line-height: 1;
      padding: 0 10px;
      line-height: 20px;
      height: 20px;
      opacity: 0.9;
    }
  }
}
</style>
